import { INTERIOR_MIN_SIZE } from "../constants/dimensionLimits";

/**
 * Rescale a list of sizes by `target / live`, so they keep their proportions as
 * the dimension they divide up changes.
 *
 * Both ends are absolute rather than incremental, so re-running this for the
 * frames that share one drag context converges on the same arrangement instead
 * of scaling repeatedly. An unchanged dimension returns `null`: rounding is
 * lossy, and a drag released where it started must not nudge sizes the user
 * entered off-grid.
 *
 * Sizes round to whole millimetres rather than to the drag grid — rounding each
 * entry to 10 mm would let the achieved total drift several millimetres from
 * the target, which shows up as the case not following the pointer.
 */
export function scaleToTarget(
  values: number[],
  live: number,
  target: number,
): number[] | null {
  if (live <= 0 || target === live) return null;
  const scale = target / live;
  return values.map((value) =>
    Math.max(INTERIOR_MIN_SIZE, Math.round(value * scale)),
  );
}
